export function timestampToDate(timestamp) {
  const date = timestamp.toDate();
  return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
}

export function timestampHour(timestamp) {
  const date = timestamp.toDate();
  const hour = date.getHours();
  let minutes = date.getMinutes();
  if (minutes < 10) {
    minutes = `0${minutes}`;
  }
  return `${hour}:${minutes}`;
}

export function formatDate(dateString) {
  const date = new Date(dateString);
  return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
}

export function millisecondsToMinutes(time) {
  return Math.ceil(time / 1000 / 60);
}
